import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { userHasFeature } from 'src/app/helper/userHasFeature';
import { FeatureEnum } from 'src/app/models/enums/FeatureEnum';
import { VariantEvaluationService } from '../VariantEvaluation.service';
import { TravelMix } from 'src/app/models/TravelMix.model';
import { TrainEvaluationService } from '../TrainEvaluation.service';

@Component({
    selector: 'app-evaluation-travel-mixes',
    templateUrl: './evaluation-travel-mixes.component.html',
    styleUrls: ['./evaluation-travel-mixes.component.scss']
})
export class EvaluationTravelMixesComponent implements OnInit, OnDestroy {
    @Input() evaluationService: VariantEvaluationService | TrainEvaluationService;

    private destroy$: Subject<void> = new Subject();
    private showFeatureHarbourConnection: boolean;
    private travelMixFilter = {
        airportConnection: undefined,
        harbourConnection: undefined,
        seasons: undefined
    };

    public travelmixFilterTitel = 'Travelmix filter';
    public travelmixSelectionTitel = 'Travelmix selection';
    public connectionsSource;
    public selectedConnections: string[];
    public seasonsSource = [{ Value: 1, Name: 'Summer' }, { Value: 2, Name: 'Winter' }, { Value: 3, Name: 'Transition period between seasons' }, { Value: 4, Name: 'Average values' }];
    public selectedSeasons: number[];

    private get selectedTravelMixList() {
        if (this.evaluationService.selectedTravelMixList) {
            return this.evaluationService.selectedTravelMixList;
        }
        return undefined;
    }

    public get travelMixList() {
        if (this.evaluationService.selectedTravelMixList) {
            return this.evaluationService.travelMixList;
        }
        return undefined;
    }

    public get travelMixListFiltered() {
        if (this.evaluationService.travelMixListFiltered) {
            return this.evaluationService.travelMixListFiltered;
        }
        return undefined;
    }

    constructor(private authService: AuthService) {
        this.showFeatureHarbourConnection = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideHarbourConnectionEvaluation);
    }

    ngOnInit(): void {
        this.initializeConnectionFilterSource();
    }

    initializeConnectionFilterSource() {
        let tmpConnectionsSource = [{ Value: 1, Name: 'Airport connection' }];
        if (this.showFeatureHarbourConnection) {
            tmpConnectionsSource.push({ Value: 2, Name: 'Harbour connection' });
        }
        this.connectionsSource = tmpConnectionsSource;
    }

    connectionFilterChange() {
        const airportconnection = 'Airport connection';
        const harbourconnection = 'Harbour connection';
        if (this.selectedConnections.includes(airportconnection)) {
            this.setAirportFilter(true);
        }
        else {
            this.setAirportFilter(false);
        }

        if (this.selectedConnections.includes(harbourconnection)) {
            this.setHarbourConnectionFilter(true);
        } else {
            this.setHarbourConnectionFilter(false);
        }
    }

    setAirportFilter(state) {
        if (state) {
            this.travelMixFilter.airportConnection = (airportConnection) => state == airportConnection;
        } else {
            this.travelMixFilter.airportConnection = undefined;
        }
        this.evaluationService.filterTravelMix(this.travelMixFilter);
    }

    setHarbourConnectionFilter(state) {
        if (state) {
            this.travelMixFilter.harbourConnection = (harbourConnection) => state == harbourConnection;
        } else {
            this.travelMixFilter.harbourConnection = undefined;
        }
        this.evaluationService.filterTravelMix(this.travelMixFilter);
    }

    saisonFilterChange() {
        if (this.selectedSeasons.length == 0) {
            this.travelMixFilter.seasons = undefined;
        } else {
            this.travelMixFilter.seasons = (seasons) => this.selectedSeasons.some(e => seasons.indexOf(e) !== -1);
        }
        this.evaluationService.filterTravelMix(this.travelMixFilter);
    }

    selectedTravelmixesContains(travelOption: TravelMix) {
        return this.selectedTravelMixList.indexOf(travelOption) !== -1;
    }

    processTravelOption(travelOption: TravelMix) {
        if (!this.selectedTravelmixesContains(travelOption)) {
            this.evaluationService.addToSelectedTravelmixes(travelOption);
        }
        else {
            this.evaluationService.removeFromSelectedtravelMixes(travelOption);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}